import { Product } from '../../../models/Product';
import ProductCard from '../card/ProductCard';
import './ProductGrid.less';

export type ProductGridProps = {
    className?: string;
    products: Product[];
    animationDelayOffset?: number;
    animationDelayStep?: number;
    source: 'brilliant' | 'web';
    featureType:
        | 'product-search-new'
        | 'product-search-by-text'
        | 'product-search-similar'
        | 'product-search-combinations'
        | 'product-search-complementary-category'
        | 'product-search-similar-by-image'
        | 'product-search-combinations-by-image';
};

const ProductGrid = ({
    className = '',
    products,
    animationDelayOffset = 0,
    animationDelayStep = 50,
    source,
    featureType
}: ProductGridProps) => (
    <div className={`bri-ProductGrid ${className}`}>
        {products.map((product, productIndex) => (
            <ProductCard
                key={'product-' + product.productId}
                animationDelay={
                    animationDelayOffset + productIndex * animationDelayStep
                }
                product={product}
                source={source}
                featureType={featureType}
            />
        ))}
    </div>
);

export default ProductGrid;
